import { Box, styled } from "@mui/material";
import FlexBox from "components/flexbox/FlexBox";
import FlexBetween from "components/flexbox/FlexBetween";
import LayoutDrawer from "layouts/layout-parts/LayoutDrawer";
import MultiLevelMenu from "./MultiLevelMenu";
import { useEffect, useRef } from "react";

const TOP_HEADER_AREA = 70;

const Container = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.background.paper,
  overflow: "hidden",
}));

const NavScrollArea = styled(Box)(({ theme }) => ({
  flex: "1 1 0",
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  overscrollBehavior: "contain",
  scrollbarWidth: "thin",
  scrollbarColor:
    theme.palette.mode === "dark" ? "#555 #1e1e1e" : "#c1c1c1 #f1f1f1",
  "&::-webkit-scrollbar": {
    width: 8,
  },
  "&::-webkit-scrollbar-track": {
    background: theme.palette.mode === "dark" ? "#1e1e1e" : "#f1f1f1",
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-thumb": {
    background: theme.palette.mode === "dark" ? "#555" : "#c1c1c1",
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: theme.palette.mode === "dark" ? "#777" : "#a8a8a8",
  },
}));

const NavWrapper = styled(Box)(() => ({
  paddingLeft: 16,
  paddingRight: 16,
  paddingBottom: 16,
}));

const MobileSidebar = ({ showMobileSideBar, setShowMobileSideBar }) => {
  const navScrollRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const containerEl = containerRef.current;
    const navEl = navScrollRef.current;
    if (!containerEl || !navEl) return undefined;

    const handleWheel = (event) => {
      if (navEl.scrollHeight <= navEl.clientHeight) return;

      event.preventDefault();
      event.stopPropagation();

      const maxScrollTop = navEl.scrollHeight - navEl.clientHeight;
      navEl.scrollTop = Math.max(0, Math.min(maxScrollTop, navEl.scrollTop + event.deltaY));
    };

    containerEl.addEventListener("wheel", handleWheel, { passive: false });
    return () => containerEl.removeEventListener("wheel", handleWheel);
  }, [showMobileSideBar]);

  return (
    <LayoutDrawer open={showMobileSideBar} onClose={setShowMobileSideBar}>
      <Container ref={containerRef}>
        <FlexBetween
          pt={2}
          pr={3}
          pl={3}
          pb={1}
          minHeight={TOP_HEADER_AREA}
          sx={{ flexShrink: 0 }}
        >
          <FlexBox alignItems="center" gap={1}>
            <img
              src="/nextgen/nextgen_logo.png"
              alt="NextGen Logo"
              style={{ height: 40, maxWidth: 160, objectFit: "contain" }}
            />
          </FlexBox>
        </FlexBetween>

        <NavScrollArea ref={navScrollRef}>
          <NavWrapper>
            <MultiLevelMenu sidebarCompact={false} />
          </NavWrapper>
        </NavScrollArea>
      </Container>
    </LayoutDrawer>
  );
};

export default MobileSidebar;
